import React, { useRef } from 'react';
import { MenuCard } from './MenuCard';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { KebabIcon } from './SectionIcons';
export function Kebabs() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="menu" className="w-full bg-bp-bg py-20 px-6 md:px-20" data-id="element-62">
      <div className="max-w-container mx-auto" data-id="element-63">
        <motion.div ref={ref} className="flex flex-col items-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6
      }} data-id="element-64">
          <KebabIcon className="mb-4" data-id="element-65" />
          <h2 className="font-display text-[32px] md:text-[48px] leading-none text-bp-text tracking-[0.1em] uppercase text-center" data-id="element-66">
            KEBABS
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-67">
          <MenuCard name="POLLO" price="18.000" ingredients={['Pan artesanal.', 'Pollo marinado.', 'Cebolla encurtida.', 'Mix de vegetales frescos.', 'Salsa de ajo.']} delay={0} data-id="element-68" />

          <MenuCard name="RES" price="18.000" ingredients={['Pan artesanal.', 'Res marinada.', 'Cebolla encurtida.', 'Mix de vegetales frescos.', 'Salsa de ajo.']} delay={0.1} data-id="element-69" />

          <MenuCard name="FALAFEL" price="18.000" ingredients={['Pan artesanal.', 'Falafel de garbanzo.', 'Cebolla encurtida.', 'Mix de vegetales frescos.', 'Salsa de ajo.']} isVegetarian delay={0.2} data-id="element-70" />
        </div>

        {/* Salsa Brava Block */}
        <motion.div className="bg-bp-bg3 border border-bp-line2 rounded-bp p-8 max-w-2xl mx-auto text-center" initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 20
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} data-id="element-71">
          <h3 className="font-display text-3xl text-bp-accent tracking-wider uppercase mb-6" data-id="element-72">
            SALSA BRAVA
          </h3>

          <div className="flex flex-wrap justify-center gap-10" data-id="element-73">
            <p className="font-body font-light text-bp-text2 text-base flex items-center gap-2" data-id="element-74">
              <span data-id="element-75">○</span> Sin picante
            </p>
            <p className="font-body font-light text-bp-text2 text-base flex items-center gap-2" data-id="element-76">
              <span data-id="element-77">◐</span> Medio
            </p>
            <p className="font-body font-light text-bp-text2 text-base flex items-center gap-2" data-id="element-78">
              <span data-id="element-79">●</span> Alto
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}